import classNames from 'classnames'

import classes from './Banner.module.scss'
import { Box } from '@percent/lemonade'
import { BannerProps } from './Banner.types'

export function Banner({ children, testId, className }: BannerProps) {
  return (
    <Box className={classNames(classes.banner, className)} data-testid={testId}>
      {children}
    </Box>
  )
}
